import { Button, Typography } from "@mui/material";
import RpMUIDialog from "@/components/modals/RpMUIModal";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

type PreviewOnlyDialogProps = {
  open: boolean;
  onClose: () => void;
};

function PreviewOnlyDialog({ open, onClose }: PreviewOnlyDialogProps) {
  return (
    <RpMUIDialog open={open} onClose={onClose}>
      <div className="text-center py-2">
        <RpSvgIcon
          name="campaign_not_authorized"
          className="mx-auto"
          size={150}
        />
        <Typography variant="h6" textAlign="center" className="my-4 px-2">
          You are not authorized to activate this campaign. Please contact the
          franchisee to activate.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          disableElevation
          onClick={onClose}
          sx={{ mt: 1, px: 10 }}
        >
          OK
        </Button>
      </div>
    </RpMUIDialog>
  );
}

export default PreviewOnlyDialog;
